import { useEffect, useState } from "react";
import Cross from "../../../assets/icons/Cross";
import DefaultButton from "../../default-button/DefaultButton";
import ArrowLeft from "../../../assets/icons/ArrowLeft";
import Tick from "../../../assets/icons/Tick";
import { Category } from "../../../misc/types";
import { categories } from "../../../misc/constants";
import { useHookstate } from "@hookstate/core";
import { onInputChangeNative, showSnackbar, updateLocalStateRaw } from "../../../misc/utils";
import { useGlobalMiscState } from "../../../stores/misc";
import { simpleGetter } from "../../../actions/common";
import { socialTranscriptApi } from "../../../api/api";
import InputField from "../../input-field/InputField";

type Props = {
  setIsAddCategoryModalOpen: (value: boolean) => void;
};

type SocialCategoryCreateBody = {
  name: string;
  id?: number;
}

let idCounter = categories.length;

export default function CategoryModal({ setIsAddCategoryModalOpen }: Props) {
  const miscState = useGlobalMiscState();
  const localState = useHookstate({});
  const state: Record<string, any> = localState.get();
  const socialTranscriptCurrentCategory = miscState.get('socialTranscriptCurrentCategory');
  const input = state.input || "";

  useEffect(() => {
    if (socialTranscriptCurrentCategory?.name) {
      updateLocalStateRaw(localState, 'input')(socialTranscriptCurrentCategory?.name)
    }
  }, [socialTranscriptCurrentCategory?.name])

  const submit = async () => {
    const body: SocialCategoryCreateBody = {
      name: input
    };
    if (socialTranscriptCurrentCategory) {
      body.id = socialTranscriptCurrentCategory.id
    }
    const response = await simpleGetter(socialTranscriptApi.createCategory, body)
    showSnackbar(response.success ? 'Успешно' : 'Произошла ошибка', response.success ? 'success' : 'error')
    if (response.success) {
      miscState.setBatch({
        socialTranscriptIsAddModalOpen: false,
        socialTranscriptTriggerFetch: (miscState.get('socialTranscriptTriggerFetch') || 0) + 1
      })
    }
  }

  return (
    <div className="w-fit p-8 rounded-xl bg-white text-black absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col">
      <div>
        <div
          onClick={() => setIsAddCategoryModalOpen(false)}
          className="flex justify-end cursor-pointer"
        >
          <Cross additionalStyle="text-[#5F6B88]" />
        </div>
        <p className="text-black font-normal text-[24px]">Создание категории</p>
      </div>
      <div className="flex-grow mt-8">
        <p className="mb-2 font-medium text-[15px] text-[#5F6B88]">
          Название категории
        </p>
        <InputField
          type="text"
          value={input}
          handleChange={onInputChangeNative(localState, 'input')}
          additionalClassName="bg-valley-background-blue py-3 px-4 text-valley-black rounded-lg"
        />
      </div>
      <div className="grid grid-cols-[5fr_7fr] gap-3 mt-4">
        <DefaultButton
          buttonText="Вернуться"
          additionalStyle="bg-[#5F6B88] text-white px-8 py-3 text-nowrap"
          Icon={ArrowLeft}
          onClick={() => setIsAddCategoryModalOpen(false)}
        />
        <DefaultButton
          buttonText="Создать категорию"
          additionalStyle="bg-[#0068FF] text-white px-8 py-3 text-nowrap"
          Icon={Tick}
          onClick={submit}
          disabled={!input.length}
        />
      </div>
    </div>
  );
}
